export default "__VITE_ASSET__Cj4Pf2mo__"